export const defaultTemplate = {
  name: '',
  scenarioCategory: '',
  description: '',
  createdBy: '',
  creationDate: '',
  dispatchScenario: '',
  dispatchTime: '',
  location: '',
  natureOfCall: '',
  weather: '',
  personnelAtScene: '',
  // Equipment and Setup fields
  props: 'Manikin',
  soundClips: 'NA',
  medicalIdentificationJewelry: 'Medical Alert wrist band',
  setupInstructions: 'Teen aged patient sitting in highschool nurses office',
  // Background Information fields
  emsSystemDescription: 'EMT Service',
  otherAncillaryPersonnel: '1 EMT level Team lead\n2 EMT level Team members',
  // Patient Moulage Information fields
  integumentary: 'Cool, pale moist',
  head: 'No DCAP- BTLS',
  chest: 'No DCAP- BTLS',
  abdomen: 'No DCAP- BTLS',
  pelvis: 'No DCAP- BTLS',
  back: 'No DCAP- BTLS',
  extremities: 'No DCAP- BTLS - insulin pump left upper arm',
  rows: [
    { item: '', objective: '', notes: '', score: '', value: '', critical: false },
  ],
};

export const defaultTemplates = [
  {
    name: "Cardiac Arrest Scenario",
    description: "Basic cardiac arrest response scenario",
    rows: [
      { item: 'Scene Safety', objective: 'Assess scene for safety hazards', notes: 'Look for electrical hazards, traffic, body fluids, etc.', score: '', value: '', critical: true },
      { item: 'BSI/PPE', objective: 'Don appropriate personal protective equipment', notes: 'Gloves, eye protection, mask as needed', score: '', value: '', critical: true },
      { item: 'Primary Assessment', objective: 'Check responsiveness and breathing', notes: 'Tap shoulders, shout "Are you okay?", look for normal breathing', score: '', value: '', critical: true },
      { item: 'Call for Help', objective: 'Activate emergency response system', notes: 'Call 911, request AED if available', score: '', value: '', critical: true },
      { item: 'Pulse Check', objective: 'Check for carotid pulse', notes: 'No more than 10 seconds', score: '', value: '', critical: true },
      { item: 'CPR', objective: 'Begin chest compressions', notes: '30:2 ratio, 100-120 compressions per minute, 2+ inches deep', score: '', value: '', critical: true },
      { item: 'AED', objective: 'Apply AED when available', notes: 'Turn on, attach pads, ensure everyone is clear', score: '', value: '', critical: false }
    ]
  },
  {
    name: "Choking Adult Scenario", 
    description: "Conscious adult choking response",
    rows: [
      { item: 'Recognition', objective: 'Identify signs of choking', notes: 'Universal choking sign, inability to speak, cyanosis', score: '', value: '', critical: true },
      { item: 'Consent', objective: 'Ask permission to help', notes: '"Are you choking? Can I help you?"', score: '', value: '', critical: true },
      { item: 'Back Blows', objective: 'Deliver 5 back blows', notes: 'Lean patient forward, heel of hand between shoulder blades', score: '', value: '', critical: false },
      { item: 'Abdominal Thrusts', objective: 'Perform 5 abdominal thrusts', notes: 'Heimlich maneuver, upward and inward thrusts', score: '', value: '', critical: true },
      { item: 'Continue Cycle', objective: 'Alternate back blows and thrusts', notes: 'Continue until object expelled or patient becomes unconscious', score: '', value: '', critical: true },
      { item: 'Follow-up', objective: 'Encourage medical evaluation', notes: 'Recommend seeing doctor even if object expelled', score: '', value: '', critical: false }
    ]
  },
  {
    name: "Trauma Assessment Scenario",
    description: "Multi-system trauma patient assessment",
    rows: [
      { item: 'Scene Safety', objective: 'Assess mechanism of injury and scene safety', notes: 'MVA, fall, violence - ensure scene is secure', score: '', value: '', critical: true },
      { item: 'BSI/PPE', objective: 'Universal precautions', notes: 'Gloves, eye protection, consider C-spine', score: '', value: '', critical: true },
      { item: 'Primary Survey', objective: 'ABCDE assessment', notes: 'Airway, Breathing, Circulation, Disability, Exposure', score: '', value: '', critical: true },
      { item: 'C-Spine Control', objective: 'Maintain spinal immobilization', notes: 'Manual stabilization or cervical collar', score: '', value: '', critical: true },
      { item: 'Vital Signs', objective: 'Obtain baseline vital signs', notes: 'BP, pulse, respirations, temperature', score: '', value: '', critical: false },
      { item: 'Secondary Survey', objective: 'Head-to-toe assessment', notes: 'Systematic examination for injuries', score: '', value: '', critical: false },
      { item: 'Transport Decision', objective: 'Determine transport priority', notes: 'High priority if unstable vital signs or mechanism', score: '', value: '', critical: true }
    ]
  }
];
